import { Component, OnInit } from '@angular/core';
import {ApiService} from "../../../../services/api.service";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {BehaviorSubject} from "rxjs";
import {NzModalRef} from "ng-zorro-antd/modal";

@Component({
  selector: 'app-provide-feedback-modal',
  templateUrl: './provide-feedback-modal.component.html',
  styleUrls: ['./provide-feedback-modal.component.scss']
})
export class ProvideFeedbackModalComponent implements OnInit {

  feedbackForm: FormGroup;
  $submitting: BehaviorSubject<boolean>;
  $submitted: BehaviorSubject<boolean>;

  constructor(public api: ApiService, public fb: FormBuilder, public modal: NzModalRef) {
    this.$submitted = new BehaviorSubject<boolean>(false);
    this.$submitting = new BehaviorSubject<boolean>(false);
    this.feedbackForm = fb.group({
      feedback: [null, Validators.required],
      type: [null, Validators.required]
    });
  }

  ngOnInit(): void {
  }

  submitFeedback(){

    this.$submitting.next(true);
    this.api.apiPost('/api/feedback', this.feedbackForm.value).then((res)=>{
      this.$submitted.next(true);
      this.$submitting.next(false);
    })

  }

  destroyModal(): void {
    this.modal.destroy();
  }

}
